import React, { useState } from 'react'
import { FileText as FileTextIcon, Moon as MoonIcon } from 'react-feather'
import { Button, makeStyles, Box } from '@material-ui/core'

import QuestionsReply from '../QuestionsReply'
import RecommendedQuestions from '../RecommendedQuestions'
import InactiveQuestions from '../InactiveQuestions'

import styles from './styles'
import constants from 'constants/index'
import helpers from 'helpers'

const useStyles = makeStyles(styles)
const {
  USER_QUESTIONS_TAB_VALUE,
  RECOMMENDED_QUESTIONS_TAB_VALUE,
  INACTIVE_QUESTIONS_TAB_VALUE,
} = constants.questionnaire

const QuestionnairesTabHeader = ({
  questionnaire,
  isLoading,
  refresh = () => {},
  companyKind,
}) => {
  const [currentTab, setCurrentTab] = useState(USER_QUESTIONS_TAB_VALUE)

  const classes = useStyles()

  const isActive = (tab) => {
    return tab === currentTab
  }

  const activeStyles = {
    color: 'primary',
    classes: { label: classes.textWhite },
  }

  const activeQuestions = helpers.questionnaires.filterQuestions(
    questionnaire?.questions || [],
    {
      status: [
        constants.questions.ANSWERED_STATUS,
        constants.questions.PENDING_STATUS,
      ],
    },
  )
  const applicableChoiceQuestions = helpers.questionnaires.filterQuestions(
    activeQuestions || [],
    {
      applicableChoice: true,
    },
  )
  const answeredQuestions = helpers.questionnaires.filterQuestions(
    applicableChoiceQuestions || [],
    {
      status: constants.questions.ANSWERED_STATUS,
    },
  )
  const pendingQuestions = helpers.questionnaires.filterQuestions(
    applicableChoiceQuestions || [],
    {
      status: constants.questions.PENDING_STATUS,
    },
  )
  const inactiveQuestions = helpers.questionnaires.filterQuestions(
    questionnaire?.questions || [],
    {
      status: constants.questions.INACTIVE_STATUS,
    },
  )
  const notApplicableChoiceQuestions = helpers.questionnaires.filterQuestions(
    activeQuestions || [],
    {
      applicableChoice: false,
    },
  )

  const questions = {
    active: activeQuestions,
    applicableChoice: applicableChoiceQuestions,
    answered: answeredQuestions,
    pending: pendingQuestions,
    inactive: inactiveQuestions,
    notApplicableChoice: notApplicableChoiceQuestions,
  }

  return (
    <>
      <Button
        disableElevation
        startIcon={<FileTextIcon size={18} />}
        variant="contained"
        onClick={() => setCurrentTab(USER_QUESTIONS_TAB_VALUE)}
        {...(isActive(USER_QUESTIONS_TAB_VALUE) && activeStyles)}
        className={classes.button}
      >
        Minhas Questões
      </Button>
      <Button
        id={constants.questionnaire.QUESTIONNAIRE_REPLY_DRIVER_STEP_2}
        disableElevation
        startIcon={<FileTextIcon size={18} />}
        variant="contained"
        onClick={() => setCurrentTab(RECOMMENDED_QUESTIONS_TAB_VALUE)}
        {...(isActive(RECOMMENDED_QUESTIONS_TAB_VALUE) && activeStyles)}
        className={classes.button}
      >
        Outras Questões
      </Button>
      <Button
        disableElevation
        startIcon={<MoonIcon size={18} />}
        variant="contained"
        onClick={() => setCurrentTab(INACTIVE_QUESTIONS_TAB_VALUE)}
        {...(isActive(INACTIVE_QUESTIONS_TAB_VALUE) && activeStyles)}
        className={classes.button}
      >
        Questões Inativas
      </Button>
      <Box>
        {currentTab === USER_QUESTIONS_TAB_VALUE && (
          <QuestionsReply
            questionnaire={questionnaire}
            isLoading={isLoading}
            refresh={refresh}
            companyKind={companyKind}
            questions={questions}
          />
        )}
        {currentTab === RECOMMENDED_QUESTIONS_TAB_VALUE && (
          <RecommendedQuestions
            displayQuestions={questions?.notApplicableChoice}
            setCurrentTab={setCurrentTab}
            questionnaireId={questionnaire?.id}
            refresh={refresh}
          />
        )}
        {currentTab === INACTIVE_QUESTIONS_TAB_VALUE && (
          <InactiveQuestions displayQuestions={questions?.inactive} />
        )}
      </Box>
    </>
  )
}

export default QuestionnairesTabHeader
